import 'core-js/stable';
import 'regenerator-runtime/runtime';
import React from 'react';
import LoadingBar from 'react-redux-loading-bar';
import { translate } from 'react-i18next';
import {
    Switch,
    Route,
    Redirect,
} from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ProjectsPage from '../containers/projects/ProjectsPage';
import PromotePage from '../containers/promote/PromotePage';
import AnalyticsPage from '../containers/analytics/AnalyticsPage';
import Messages from '../containers/messages/Messages';
import Catch404 from '../containers/pages/Catch404';
import LoggedOut from '../containers/pages/LoggedOut';
import Templates from '../containers/projects/Templates';
import VersionViews from '../containers/projects/VersionViews';
import Login from './common/login';
import '../assets/styles/master.css';
import AlertLoader from '../containers/alerts/AlertLoader';
import PermissionsMessage from './permissionsMessage/permissionsMessage';
import LoginMessage from './permissionsMessage/loginMessage';
import VimeoRedirector from './VimeoRedirector';
import '../i18n';
import ErrorBoundary from './ErrorBoundary';
import _actions from '../actions';
import AppBuilderHeader from '../containers/header/AppBuilderHeader';
import Header from '../containers/header/Header';
import { APP_TITLE, ENVIRONMENT } from '../utilities/constants';
import PlatformUpAndFms from "./PlatformUpAndFms";

require('typeface-montserrat');

require('typeface-roboto');

class App extends React.Component {
    componentDidMount() {
        //const script = document.createElement('script');
        //script.src = window.GENESIS_HELP_MODAL_URL;
        //script.async = true;
        //document.body.appendChild(script);
        //this.initiateHelp();
        const gtag = document.createElement('script');
        gtag.src = 'https://www.googletagmanager.com/gtag/js?id=UA-151181836-1';
        gtag.async = true;
        const gtag2 = document.createElement('script');
        gtag2.innerHTML = 'window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag(\'js\', new Date());gtag(\'config\', \'UA-151181836-1\');';
        document.head.appendChild(gtag);
        document.head.appendChild(gtag2);
        const script2 = document.createElement('script');
        script2.src = `${window.WAFFLE_API_URL}/embed.js`;
        script2.crossOrigin = 'anonymous';
        document.head.appendChild(script2);
        this.initiateWaffle();
        const script3 = document.createElement('script');
        script3.src = window.ANALYTICS_URL;
        script3.crossOrigin = 'anonymous';
        document.head.appendChild(script3);

        const bar = document.createElement('script');
        bar.type = 'text/javascript';
        bar.src = 'https://cdnjs.cloudflare.com/ajax/libs/simplebar/5.2.1/simplebar.min.js';
        document.getElementsByTagName('head')[0].appendChild(bar);

        const barcss = document.createElement('link');
        barcss.href = 'https://cdnjs.cloudflare.com/ajax/libs/simplebar/5.2.1/simplebar.min.css';
        barcss.rel = 'stylesheet';
        document.getElementsByTagName('head')[0].appendChild(barcss);
        // this.props.actions.getCurrentAuthAction('Test data');

        function addZenDeskWidget() {
            if (window.location.hostname.includes('easytithepro')) {
                const zendesk = document.createElement('script');
                zendesk.id = 'ze-snippet';
                zendesk.src = 'https://static.zdassets.com/ekr/snippet.js?key=31987f10-a27d-4855-bae7-dcdab82df59b';
                document.getElementsByTagName('head')[0].appendChild(zendesk);
            }
        }
        addZenDeskWidget();
    }

    //eslint-disable-next-line react/sort-comp
    // initiateHelp() {

    //     if (window.com?.mb?.documentation && !window.jQuery) {
    //         window.com.mb.documentation.init();
    //     } else {
    //         setTimeout(() => {
    //             this.initiateHelp();
    //         }, 2000);
    //     }

    // }

    initiateWaffle() {
        const el = document.getElementById('mb-waffle');
        if (window.com?.mb?.waffle?.tasteTest && el?.dataset && el?.dataset?.token?.length > 0) {
            window.com.mb.waffle.tasteTest();
        } else {
            setTimeout(() => {
                this.initiateWaffle();
            }, 2000);
        }
    }
    
    // eslint-disable-next-line react/sort-comp
    constructor(props) {
        super(props);
        this.state = { access: false };
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.profiles?.data?.length !== prevProps.profiles?.data?.length
            && prevState.access !== true && this.props.profiles?.data?.name) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({ access: true });
        }
        if (this.props.profiles?.data?.length === 0 && prevState.access !== false) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({ access: false });
        }
        if (this.props.location.pathname.indexOf('logged-out') === -1
            && prevProps.location.pathname.indexOf('logged-out') !== -1) {
            setTimeout(this.props.actions.getCurrentProfile(this.props.profiles), 10000);
        }
        const { location: { pathname } } = this.props;
        const previousLocation = prevProps.location.pathname;
    }

    render() {
        let alert = '';
        let header = '';
        function setFaviconIcon(){
            let environment = localStorage.getItem('environment');
            if (environment !==  ENVIRONMENT.LEGACY){
                let link = document.querySelector("link[rel*='icon']");
                link.rel = 'icon';
                link.href = '/Bands.ico';
                document.head.appendChild(link);
            }
        }
        function setEnvironment() {
            let environment = ''
            if (window.location.hostname === 'localhost') {
                if (ENVIRONMENT.LOCAL === ENVIRONMENT.LEGACY) {
                    window.IS_LOCAL_UNITY = false;
                }
                localStorage.setItem('IsUnity', window.IS_LOCAL_UNITY);
                environment = ENVIRONMENT.LOCAL;
            } else if (window.location.hostname.startsWith('app.ministryone')) {
                localStorage.setItem('IsUnity', false);
                environment = ENVIRONMENT.MINISTRY_ONE
            } else if (window.location.hostname.includes(ENVIRONMENT.AMPLIFY)) {
                localStorage.setItem('IsUnity', true);
                environment = ENVIRONMENT.AMPLIFY;
            }
            else if (window.location.hostname.startsWith('legacy')) {
                localStorage.setItem('IsUnity', false);
                environment = ENVIRONMENT.LEGACY;
            } else if (window.location.hostname.includes(ENVIRONMENT.MY_PARISH_SOFT)) {
                localStorage.setItem('IsUnity', true);
                environment = ENVIRONMENT.MY_PARISH_SOFT;
            }
            else {
                localStorage.setItem('IsUnity', false);
            }

            localStorage.setItem('environment', environment);
            if (document) {
                document.title = APP_TITLE[environment ? environment : ENVIRONMENT.LEGACY]
            }
        }
        setEnvironment();
        setFaviconIcon();
        if (this.props.location.pathname.indexOf('no-access') === -1 && this.props.location.pathname.indexOf('projects') === -1) {
            alert = (<AlertLoader />);
        }
        if (this.props.location.pathname.indexOf('no-access') === -1 && localStorage.getItem('IsUnity') === 'true') {
            header = (<AppBuilderHeader />);
        } else if (this.props.location.pathname.indexOf('no-access') === -1 && localStorage.getItem('IsUnity') === 'false') {
            header = (<Header />);
        }
        return (
            <div className="app-wrapper">
                {this.props.versions.publishProgress && <div className="publish-overlay" />}
                {header}
                <LoadingBar style={{
                    zIndex: 99999,
                    backgroundColor: '#425cbb',
                    height: '2px',
                }}
                />
                <ErrorBoundary>
                    <div
                        className={this.props.location.pathname === '/' || this.props.location.pathname === '/choose-template' ? 'app-intro-wrapper' : 'inside-wrapper'}
                    >
                        <PlatformUpAndFms />
                        {alert}
                        <Switch>
                            <Route
                                path="/permissions/:messageType"
                                component={PermissionsMessage}
                            />
                            <Route path="/no-access" component={LoginMessage} />
                            <Route
                                exact
                                path="/"
                                component={this.state.access ? ProjectsPage : LoginMessage}
                            />
                            <Route
                                exact
                                path="/projects"
                            >
                                <Redirect to="/" />
                            </Route>
                            <Route
                                exact
                                path="/promote"
                                component={this.state.access ? PromotePage : LoginMessage}
                            />
                            <Route
                                exact
                                path="/analytics"
                                component={this.state.access ? AnalyticsPage : LoginMessage}
                            />
                            <Route
                                exact
                                path="/messages"
                                component={this.state.access ? Messages : LoginMessage}
                            />
                            <Route exact path="/login" component={Login} />
                            <Route
                                path="/projects/:projectId/template"
                                component={this.state.access ? Templates : LoginMessage}
                            />
                            <Route
                                path="/projects/:projectId/"
                                component={this.state.access ? VersionViews
                                    : LoginMessage}
                            />
                            <Route path="/logged-out" component={LoggedOut} />
                            <Route path="/vimeo-authenticator" component={VimeoRedirector} />
                            <Route component={Catch404} />
                            {/* <Route exact path="/app-builder" component={AppBuilderHeader} /> */}
                        </Switch>
                    </div>
                </ErrorBoundary>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...state,
        ...ownProps,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(_actions, dispatch),
    };
};

export default translate('translations')(connect(mapStateToProps, mapDispatchToProps)(App));
